import React from 'react';
import { Interview } from '../../../../entities/Interview';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { KeyMoment } from '../../../../entities/KeyMoment';
import { KeyMomentBox } from '../../../../components/KeyMoments/KeyMomentBox';

interface PropTypes {
  interview: Interview;
  onTimestampChange: (timestamp: number) => void;
}

export function ScorecardKeyMoments(props: PropTypes) {
  return (
    <div
      className={classNames(
        'd-flex',
        'flex-column',
        'p-3',
        'd-flex',
        'gap-2',
        'h-100',
        'fs-5',
        styles.container,
      )}
    >
      {props.interview.keyMoments.map((keyMoment: KeyMoment, index: number) => (
        <KeyMomentBox
          onSelectTimestamp={props.onTimestampChange}
          key={index}
          keyMoment={keyMoment}
        />
      ))}
    </div>
  );
}
